export const disableComponentInDev = (Component: React.ComponentType) => {
  if (process.env.NODE_ENV === 'development') {
    return () => null;
  }

  return Component;
}
